import {ChangeDetectionStrategy, Component, inject, Input, OnInit} from '@angular/core';
import {HistorienElement} from "../../core/model/historien-element";
import {getPostfachFormat} from "../../shared/utils/date-time.helper";

import i18next from "i18next";
import {I18NextPipe} from "@kokos-i18next";
import {NachrichtActionService} from "../../core/services/nachricht-action.service";
import {NachrichtSummary} from "../../core/model/nachricht/nachricht";
import {NachrichtDetailComponent} from "../../shared/components/nachricht-detail/nachricht-detail.component";
import {take} from "rxjs/operators";
import {SanitizeService} from "../../shared/utils/sanitize.service";
import {LinkifyService} from "../../shared/utils/linkify.service";
import {PersonDisplayService} from "../../core/services/person-display.service";
import {
    I18nRerenderOnLanguageChangeDirective
} from "../../shared/directives/i18n-rerender-on-language-change.directive";

type GroupedHistorienElements = { key: string; items: HistorienElement[] };

@Component({
    selector: 'kokos-nachricht-history',
    imports: [I18NextPipe, NachrichtDetailComponent, I18nRerenderOnLanguageChangeDirective],
    templateUrl: './nachricht-history.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
})
export class NachrichtHistoryComponent implements OnInit {

    @Input() nachrichtHistorie: HistorienElement[] = [];
    @Input() nachricht: NachrichtSummary;

    historienElements: GroupedHistorienElements[];

    private readonly nachrichtActionService = inject(NachrichtActionService);
    private readonly sanitizeService = inject(SanitizeService);
    private readonly linkifyService = inject(LinkifyService);
    protected readonly personDisplayService = inject(PersonDisplayService);

    protected readonly getPostfachFormat = getPostfachFormat;
    isCollapsed = true;

    ngOnInit(): void {
        this.historienElements = this.groupDatesByMonthAndYear(this.nachrichtHistorie)
    }

    toggleCollapse(): void {
        this.isCollapsed = !this.isCollapsed;
    }

    groupDatesByMonthAndYear(elements: HistorienElement[]): GroupedHistorienElements[] {
        const formatter = new Intl.DateTimeFormat(i18next.language || 'de', {
            month: 'long',
            year: 'numeric',
        });

        const grouped = new Map<string, HistorienElement[]>();

        for (const elem of elements) {
            if (elem.text) {
                const sanitized = this.sanitizeService.sanitize(elem.text?.replaceAll('\n', '<br/>'));
                elem.text = this.linkifyService.linkify(sanitized);
            }

            const key = formatter.format(new Date(elem.datum));
            (grouped.get(key) ?? grouped.set(key, []).get(key)).push(elem);
        }

        return Array.from(grouped.entries()).map(([key, items]) => ({key, items}));
    }

    downloadHistory(): void {
        this.nachrichtActionService
            .handleDownload(this.nachricht)
            .pipe(take(1))
            .subscribe();
    }
}
